import { forwardRef, useRef, ForwardedRef } from "react";
import { useTranslation } from "react-i18next";
import { CalendarPicker } from "..";
import CalendarDay from "../calendarDay";
import { getMonthList } from "../action";
import Button from "components/button/default";
import { useBookInfContext } from "components/context/bookInfContext";
import "../calendar.scss";

type IProps = {
  handleNext: () => void;
};

function CalendarMb({ handleNext }: IProps, ref: ForwardedRef<HTMLDivElement>) {
  const { t } = useTranslation();
  const { setDates, setDateRange, onBookInf } = useBookInfContext();
  const monthList = getMonthList(13);

  return (
    <>
      <div className="calendar-mb" ref={ref}>
        <CalendarDay />

        <div className="">
          {monthList.map((month) => {
            return <CalendarPicker key={month + ""} now={month} styles="" />;
          })}
        </div>
        <div className="btn-wrap">
          <button
            className="font-B text-blue-300 bg-white pb-2"
            onClick={() => {
              setDates([]);
              setDateRange([]);
              onBookInf({
                dates: [],
                dateRange: [],
              });
            }}
          >
            {t("btn_rst_cmm")}
          </button>
          <Button
            text={t("btn_nxt_cmm")}
            styels="w-[95px] text-sm"
            onClick={handleNext}
          />
        </div>
      </div>
    </>
  );
}

export default forwardRef<HTMLDivElement, IProps>(CalendarMb);
